export const HeaderSection = {
  partners: 'Socis',
  accessories: 'Accessoris',
  stages: 'Etapes',
  order: 'Sol·licitar',
};
export const description =
  `Una casa intel·ligent és el seu assistent personal que es preocupa per la seva comoditat i confort. El sistema es pot instal·lar en qualsevol lloc on visqui o treballi. Per controlar-ho, n'hi ha prou amb una tauleta, un telèfon o un ordinador. Gràcies al seu exclusiu protocol segur i a la seva aplicació mòbil, el complex li garanteix el control total de les seves instal·lacions en qualsevol moment. Per encendre la llum, obrir les cortines o apagar l'aire condicionat, no cal aixecar-se del sofà.`;
